import Content from "@/Pages/Admin/Settings/Content.vue"

export default [
    {
        path: '/admin/settings/content',
        component: Content,
        name: 'admin.settings.content',
        meta: {
            auth: true
        },
    },
];
